
/*
================================================================================

  "Case Study" page

================================================================================
*/

import $ from 'jquery';

const CaseStudyPage = (() => {
  const toggleStickySidebar = function() {
    const mainElem = document.querySelector('.main--case-study');
    const mainOffsetTop = $(mainElem).offset().top;
    const mainHeight = mainElem.offsetHeight;
    const mainOffsetBottom = mainOffsetTop + mainHeight;

    const testimonialElem = document.querySelector('.case-testimonial');
    const testimonialOffsetTop = $(testimonialElem).offset().top;
    const testimonialHeight = testimonialElem.offsetHeight;
    const testimonialOffsetBottom = testimonialOffsetTop + testimonialHeight;

    const caseSection = document.querySelector('.case-section');

    const bodyScrollTop = window.pageYOffset;
    const OFFSET = Number(window.getComputedStyle(caseSection).paddingTop.replace('px', ''));

    if (bodyScrollTop >= mainOffsetTop) {
      testimonialElem.classList.add('js-sticky');
    } else {
      testimonialElem.classList.remove('js-sticky');
    }

    if (testimonialOffsetBottom + OFFSET >= mainOffsetBottom) {
      if (!testimonialElem.classList.contains('js-stick-to-bottom')) {
        testimonialElem.classList.add('js-stick-to-bottom');
      }
    }

    if (bodyScrollTop < testimonialOffsetTop - OFFSET) {
      if (testimonialElem.classList.contains('js-stick-to-bottom')) {
        testimonialElem.classList.remove('js-stick-to-bottom');
      }
    }
  };

  const initEventListeners = function() {
    if (document.querySelector('.main--case-study')) {
      if (!matchMedia('(max-width: 63.99em)').matches) {
        window.addEventListener('load', toggleStickySidebar);
        window.addEventListener('scroll', toggleStickySidebar);
        window.addEventListener('resize', toggleStickySidebar);
      }
    }
  };

  const init = function() {
    initEventListeners();
  };

  return {
    init: init
  };

})();

export default CaseStudyPage;
